import React, {useState, useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Box, Grid, Container, Typography} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import withTheme from '@mui/styles/withTheme';
import {Auth, useAuth} from '@saltus/auth';
import {I18n} from '@aws-amplify/core';
import debug from '../../services/debug';
import LogoLarge from '../../theme/styled-components/LogoLarge';
import styles from './styles';
import './amplify.css';

const REQUEST_ACCESS = 'https://www.saltus.co.uk/portal-access';

const translations = {
  en: {
    Email: 'Email address',
    'Enter your Email': 'Enter your email address',
    'Enter your Password': 'Enter your password',
    'Send code': 'Submit',
    'Reset Password': 'Forgot your password',
    'User does not exist.': 'Incorrect username or password.',
    // Legacy strings
    'Custom auth lambda trigger is not configured for the user pool.':
      'Password cannot be empty',
    'Confirm TOTP Code': 'Please enter your 2FA app verification code',
    'Confirm SMS Code': 'Please enter your SMS verification code',
  },
};

const App = ({classes = {}}) => {
  I18n.setLanguage('en');
  I18n.putVocabularies(translations);

  const {authStatus, federatedLogin, user} = useAuth();
  const [authState, setAuthState] = useState();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (authStatus === 'authenticated') {
      debug('App nextAuthState', authStatus);

      setAuthState(authStatus);

      debug('authData', user);
    }
  }, [authStatus, user]);

  useEffect(() => {
    const employeeParam = searchParams.get('employee');

    debug('employeeParam', employeeParam);

    if (employeeParam) {
      federatedLogin();
    }
  });

  return (
    <Grid container className={classes.root}>
      <Container maxWidth="lg">
        <Grid className={classes.gridContainer} container>
          <Grid className={classes.loginGrid} item xs={12} md={6}>
            <Box className={`${classes.loginBox} ${authState}`}>
              <Auth hideSignUp />
              <Box className={classes.privacyPolicy}>
                <span>No login credentials? </span>
                <a
                  rel="nofollow noreferrer noopener"
                  target="_blank"
                  href={REQUEST_ACCESS}
                >
                  Request access
                </a>
                <br />
                <br />
                <span>We will treat your information with respect. </span>
                <br />
                <span>By logging in to your account you agree to accept our </span>
                <a
                  rel="nofollow noreferrer noopener"
                  target="_blank"
                  href={process.env.VITE_APP_PRIVACY_POLICY_URL}
                >
                  privacy policy.
                </a>
                <br />
                <br />
                <Grid container>
                  <Grid item xs={12} md={8}>
                    {process.env.VITE_APP_SHOW_EMPLOYEE_LOGIN_BTN === 'true' && (
                      <>
                        <span>Saltus employees </span>
                        <button
                          type="button"
                          className={classes.StaffLoginButton}
                          onClick={() => federatedLogin()}
                        >
                          click here
                        </button>
                      </>
                    )}
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <Typography
                      className={classes.version}
                      align="right"
                      color="inherit"
                      variant="body2"
                    >
                      <small>{process.env.VITE_APP_VERSION}</small>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Grid>
          <Grid className={classes.logoGrid} item xs={12} md={6}>
            <Box className={classes.logoBox}>
              <LogoLarge />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Grid>
  );
};

App.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
};

export default withTheme(withStyles(styles)(App));
